import jwtDecode from 'jwt-decode';

import { constants } from '@/shared/constants';
import { authCode } from '@/shared/constants/code';
import { AuthType } from '@/shared/types/common.type';

/**
 * SPRSユーザーかどうかを判定する
 *
 * Recoilのフックが使えない箇所（axiosのエラーハンドラ等）向けに、
 * localStorageのアクセストークンからserviceKindを取り出して判定する。
 */
export const isSPRSUserFromStorage = (): boolean => {
  if (typeof window === 'undefined') return false;

  const accessToken = localStorage.getItem(constants.localstorage().authInformation.accessToken);
  if (!accessToken) return false;

  try {
    const decodedAccessToken: AuthType = jwtDecode(accessToken);
    return decodedAccessToken.serviceKind === authCode.serviceKind.SPRS;
  } catch {
    return false;
  }
};
